import { render, staticRenderFns } from "./ResearcherMenu.vue?vue&type=template&id=f2432490&"
import script from "./ResearcherMenu.vue?vue&type=script&lang=js&"
export * from "./ResearcherMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports